const searchAsyncPrefix = "search-async";

export const searchAsyncActions = {
  SEARCH: `${searchAsyncPrefix}/search`,
};
